import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { zodResolver } from '@hookform/resolvers/zod'

import { useHttpClient } from '@/modules/shared/hooks/use-http-client'
import { authChangePasswordService } from '../services/auth-change-password.service'
import {
  type AuthChangePasswordSchema,
  authChangePasswordSchema,
} from '../schemas/auth-change-password.schema'

export function useAuthChangePassword() {
  const navigate = useNavigate()
  const params = useParams<{ id: string }>()

  const form = useForm<AuthChangePasswordSchema>({
    resolver: zodResolver(authChangePasswordSchema),
    defaultValues: {
      senha: '',
      confirmarSenha: '',
    },
  })

  const httpClient = useHttpClient(
    authChangePasswordService,
    {
      onSuccess: (response) => {
        if (response.status === 200) {
          navigate('/login')
        }
      },
      showToast: true,
    }
  )

  const submitAuthChangePassword = useCallback((data: AuthChangePasswordSchema) => {
    const payload = {
      token: params.id,
      newPassword: data.confirmarSenha,
    }

    httpClient.execute({ payload })
  }, [params.id, httpClient])

  return {
    form,
    isLoading: httpClient.isLoading,
    error: httpClient.error,
    submitAuthChangePassword,
  }
}